import { createSlice } from '@reduxjs/toolkit'

const appSlice = createSlice({
  name: 'app',
  initialState: {
    ready: null,
    error: null,
    problem: null,
    sidebarShow: false,
    language: 'en',
  },
  reducers: {
    startupRequest: (state) => state,
    startupSuccess: (state) => {
      return { ...state, ready: true, error: null }
    },
    startupFailed: (state, { payload }) => {
      return { ...state, ready: false, error: true, problem: payload }
    },
    sidebarToggle: (state) => {
      return { ...state, sidebarShow: !state.sidebarShow }
    },
    setLanguage: (state, { payload }) => {
      return { ...state, language: payload }
    },
  },
})

export const AppActions = appSlice.actions

export const AppSelectors = {
  isReady: (state) => state.app.ready,
  sidebarShow: (state) => state.app.sidebarShow,
  language: (state) => state.app.language,
}

export default appSlice.reducer
